export const PUBLIC_URL = {
	root: (url = '') => `${url ? url : ''}`,

	home: () => PUBLIC_URL.root(`/`),
	auth: (url = '') => PUBLIC_URL.root(`auth${url ? url : ''}`)
}

const INITIAL_PAGE = 'requests'

export const DASHBOARD_URL = {
	root: (url = '') => `${url ? url : ''}`,
	home: (url = '') => DASHBOARD_URL.root(`/${INITIAL_PAGE}${url ? url : ''}`),
	reports: (url = '') => DASHBOARD_URL.root(`/reports${url ? url : ''}`),
	reportEvents: (url = '') => DASHBOARD_URL.root(`/reportEvents${url ? url : ''}`),
	greetings: (url = '') => DASHBOARD_URL.root(`/audio-greetings${url ? url : ''}`),
	addresses: (url = '') => DASHBOARD_URL.root(`/addresses${url ? url : ''}`),
	cameras: (url = '') => DASHBOARD_URL.root(`/cameras${url ? url : ''}`),
	clients: (url = '') => DASHBOARD_URL.root(`/clients${url ? url : ''}`),
	handsets: (url = '') => DASHBOARD_URL.root(`/handsets${url ? url : ''}`),
	overview: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/overview${url ? url : ''}`),
	general: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/general${url ? url : ''}`),
	keys: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/keys${url ? url : ''}`),
	codes: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/codes${url ? url : ''}`),
	apartments: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/apartments${url ? url : ''}`),
	matrix: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/matrix${url ? url : ''}`),
	doors: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/doors${url ? url : ''}`),
	marquee: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/marquee${url ? url : ''}`),
	audio: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/audio${url ? url : ''}`),
	equalizer: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/equalizer${url ? url : ''}`),
	sip: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/sip${url ? url : ''}`),
	video: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/video${url ? url : ''}`),
	ddns: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/ddns${url ? url : ''}`),
	network: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/network${url ? url : ''}`),
	syslog: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/syslog${url ? url : ''}`),
	logs: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/logs${url ? url : ''}`),
	firmware: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/firmware${url ? url : ''}`),
	datetime: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/datetime${url ? url : ''}`),
	reboot: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/reboot${url ? url : ''}`),
	reset: (url = '') => DASHBOARD_URL.gatesDiagnostics(`/reset${url ? url : ''}`),
	guide: (url = '') => DASHBOARD_URL.root(`/guide${url ? url : ''}`),
	requests: (url = '') => DASHBOARD_URL.root(`/requests${url ? url : ''}`),
	requestDetail: (url = '') => DASHBOARD_URL.requests(`/details${url ? url : ''}`),
	chipProgramming: (url = '') => DASHBOARD_URL.requests(`/chip-programming${url ? url : ''}`),
	chipProgrammingUserData: (url = '') => DASHBOARD_URL.requests(`/chip-programming/user-data${url ? url : ''}`),
	chipProgrammingAccessInfo: (url = '') => DASHBOARD_URL.requests(`/chip-programming/access-info${url ? url : ''}`),
	gates: (url = '') => DASHBOARD_URL.root(`/gates${url ? url : ''}`),
	gatesDiagnostics: (url = '') => DASHBOARD_URL.gates(`/diagnostics${url ? url : ''}`),
	gatesEdit: (url = '') => DASHBOARD_URL.gates(`/gatesEdit${url ? url : ''}`),
	gatesMassConfig: (url = '') => DASHBOARD_URL.gates(`/gatesMassConfig${url ? url : ''}`),
	settings: (url = '') => DASHBOARD_URL.root(`/settings${url ? url : ''}`),
	users: (url = '') => DASHBOARD_URL.root(`/users${url ? url : ''}`),
	brainChat: () => DASHBOARD_URL.root('/brain-chat'),
	/** Админка RBAC/ABAC (AuthzService). */
	authzAdmin: (url = '') => DASHBOARD_URL.root(`/authz-admin${url ? url : ''}`)
}

export const DIAGNOSTICS_CONSTANTS = {
	overview: () => DASHBOARD_URL.root(`overview`),
	general: () => DASHBOARD_URL.root(`general`),
	keys: () => DASHBOARD_URL.root(`keys`),
	codes: () => DASHBOARD_URL.root(`codes`),
	apartments: () => DASHBOARD_URL.root(`apartments`),
	matrix: () => DASHBOARD_URL.root(`matrix`),
	doors: () => DASHBOARD_URL.root(`doors`),
	marquee: () => DASHBOARD_URL.root(`marquee`),
	audio: () => DASHBOARD_URL.root(`audio`),
	equalizer: () => DASHBOARD_URL.root(`equalizer`),
	sip: () => DASHBOARD_URL.root(`sip`),
	video: () => DASHBOARD_URL.root(`video`),
	ddns: () => DASHBOARD_URL.root(`ddns`),
	network: () => DASHBOARD_URL.root(`network`),
	syslog: () => DASHBOARD_URL.root(`syslog`),
	logs: () => DASHBOARD_URL.root(`logs`),
	firmware: () => DASHBOARD_URL.root(`firmware`),
	datetime: () => DASHBOARD_URL.root(`datetime`),
	reboot: () => DASHBOARD_URL.root(`reboot`),
	reset: () => DASHBOARD_URL.root(`reset`),
}

export const REQUESTS_CONSTANTS = {
	details: () => `details`,
}

export const GATES_CONSTANTS = {
	gates: () => `gates`,
	gatesEdit: () => `gatesEdit`,
}
